import api from '../../../@e74/services/ApiConfig';
import {hideMessage, fetchStart, fetchSuccess, fetchError} from '../Common';

export const ACTION_TYPES = {
  CREATE: 'CREATE_MEDICINE',
  UPDATE: 'UPDATE_MEDICINE',
  DELETE: 'DELETE_MEDICINE',
  FETCH_ALL: 'FETCH_ALL_MEDICINES',
};

export const fetchAll = () => (dispatch) => {
  dispatch(fetchStart());
  api
    .medicine()
    .fetchAll()
    .then((response) => {
      dispatch({
        type: ACTION_TYPES.FETCH_ALL,
        payload: response.data,
      });
      dispatch(fetchSuccess());
      dispatch(hideMessage());
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};
export const create = (data, onSuccess) => (dispatch) => {
  dispatch(fetchStart());
  api
    .medicine()
    .create(data)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.CREATE,
        payload: res.data,
      });
      //dispatch(showMessage('Medicine added successfully'));
      dispatch(fetchSuccess());
      onSuccess();
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const update = (id, data, onSuccess) => (dispatch) => {
  dispatch(fetchStart());
  api
    .medicine()
    .update(id, data)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.UPDATE,
        payload: {id, ...data},
      });
      //dispatch(showMessage('Medicine updated successfully'));
      dispatch(fetchSuccess());
      onSuccess();
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const Delete = (id) => (dispatch) => {
  dispatch(fetchStart());
  api
    .medicine()
    .delete(id)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.DELETE,
        payload: id,
      });
      //dispatch(showMessage('Medicine deleted successfully'));
      dispatch(fetchSuccess());
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};
